import React from 'react'
import ReactDOM from 'react-dom'
import AppDocs from 'app/AppDocs.jsx'

import 'app/assets/scss/index.scss'

const pkgPath = '/home/lapis/repos/gh/formiga-reactstrap'

const pkgJson = JSON.parse(`
  {
  "name": "formiga-reactstrap",
  "version": "0.1.9",
  "description": "A Formiga implementation for Reactstrap",
  "author": "Donato Lorenzo <donato@afialapis.com>",
  "contributors": [
    "Donato Lorenzo <donato@afialapis.com>"
  ],
  "type": "module",
  "license": "MIT",
  "repository": {
    "type": "git",
    "url": "https://github.com/afialapis/formiga-reactstrap.git"
  },
  "bugs": {
    "url": "https://github.com/afialapis/formiga-reactstrap/issues"
  },
  "homepage": "https://formiga-reactstrap.afialapis.com/",
  "files": [
    "lib",
    "dist"
  ],
  "main": "./lib/index.cjs",
  "cjs": "./dist/formiga-reactstrap.cjs",
  "browser": "./dist/formiga-reactstrap.umd.js",
  "module": "./dist/formiga-reactstrap.mjs",
  "exports": {
    "import": "./dist/formiga-reactstrap.mjs",
    "default": "./lib/index.cjs",
    "require": "./dist/formiga-reactstrap.cjs"
  },
  "scripts": {
    "clean-demo": "rm -rf demo/dist",
    "clean-lib": "rm -rf lib && mkdir lib",
    "clean-dist": "rm -rf dist && mkdir dist",
    "lint": "npx xeira lint --folder=./src",
    "test": "npx xeira test --files=./test/before.mjs,./test/units/form.cjs --t=5000",
    "lib": "npm run clean-lib && npx xeira transpile --source_folder=./src --transpile_folder=./lib",
    "dist-css": "npx sass src/assets/style.scss ./dist/styles.css",
    "dist": "npm run clean-dist && npx xeira bundle && npm run dist-css",
    "prepare": "npm run clean-demo && npm run lint && npm run test && npm run lib && npm run dist",
    "demo": "npm run clean-demo && npx xeira demo --port=8002",
    "reset": "npm run clean-demo && npm run clean-lib && npm run clean-dist && rm -fr node_modules package-lock.json && npm i"
  },
  "keywords": [
    "js",
    "react",
    "form"
  ],
  "devDependencies": {
    "react-dom": "^16.13.1",
    "sass": "^1.56.1",
    "xeira": "^0.3.3"
  },
  "dependencies": {
    "formiga": "^0.1.8"
  },
  "peerDependencies": {
    "bootstrap": ">=4.5.2",
    "prop-types": ">=15.7.2",
    "react": ">=16.13.1",
    "reactstrap": ">=8.5.1",
    "reactstrap-date-picker": "^1.0.9"
  },
  "eslintConfig": {
    "extends": [
      "./node_modules/xeira/configs/eslint.react.cjs"
    ]
  },
  "XXX_babel": {
    "extends": "./node_modules/xeira/configs/babel.react.cjs"
  }
}
`)

const arreConfig = JSON.parse(`
{
  "theme": "default",
  "company": "",
  "url": "",
  "doc_versions": [
    ""
  ],
  "md": {
    "md_keep_summary_content": false,
    "md_strip_details_tag": true
  },
  "demo_entry": "",
  "has_demo": false,
  "logo": {
    "ok": false
  },
  "favicon": {
    "main": {
      "ok": false
    }
  }
}
`)

const md_0_1_9 = decodeURIComponent(escape(window.atob(`PHNlY3Rpb24+CiMgZm9ybWlnYS1yZWFjdHN0cmFwCgoKCkEgUmVhY3RzdHJhcCBpbXBsZW1lbnRhdGlvbiBvZiBGb3JtaWdhIA==`)));


const readmes = {
"0.1.9": md_0_1_9,
}



ReactDOM.render(
  <AppDocs 
    pkgPath = {pkgPath}
    pkgJson = {pkgJson}
    arreConfig = {arreConfig}
    readmes = {readmes}      
  />,
  document.getElementById('arredemo-app'))

/*

// React 18

ReactDOM.createRoot(document.getElementById("arredemo-app")).render(
  <React.StrictMode>
    <AppDocs 
      pkgPath = {pkgPath}
      pkgJson = {pkgJson}
      arreConfig = {arreConfig}
      readmes = {readmes}      
    />
  </React.StrictMode>
);
*/

